import React from "react";
import {
  ClassicBadge,
  ColorBadge,
  FullWidthColorBadge,
} from "./MacaronBadge.styled";
import { IMacaronTemplate } from "./MacronBadge.interface";
import Typography from "../../../Foundation/Typography/Typography";
import { useMacaronBadgeLogic } from "./useMacaronBadgeLogic";

export interface IMacaronBadgeProps {
  name: string;
  color: string;
  textColor?: string;
  template?: IMacaronTemplate;
  className?: string;
}

/**
 * MacaronBadge component renders a badge with different styles based on template type
 */
const MacaronBadge = ({
  name,
  color,
  textColor = "#ffffff",
  template = "classic",
  className,
}: IMacaronBadgeProps) => {
  // Use the custom hook to handle the logic
  const { badgeStyle } = useMacaronBadgeLogic({
    color,
    textColor,
    template,
  });
  const { backgroundColor: bgColor, color: txtColor } = badgeStyle || {};

  // Render the appropriate template
  switch (template) {
    case "color":
      return (
        <ColorBadge $bgColor={bgColor} className={className}>
          <Typography variant="ui" color={() => txtColor}>
            {name}
          </Typography>
        </ColorBadge>
      );

    case "color_and_background":
      return (
        <ColorBadge $bgColor={bgColor} className={className}>
          <Typography variant="ui" color={() => txtColor}>
            {name}
          </Typography>
        </ColorBadge>
      );

    case "color_and_border":
      return (
        <FullWidthColorBadge $bgColor={bgColor} className={className}>
          <Typography variant="ui" color={() => txtColor}>
            {name}
          </Typography>
        </FullWidthColorBadge>
      );

    default:
    case "classic":
      return (
        <ClassicBadge className={className}>
          <Typography variant="ui">{name}</Typography>
        </ClassicBadge>
      );
  }
};

export default MacaronBadge;
